const registerStyles = {
  '.pageContainer': {
    height: '950px',
    maxWidth: 'none !important',
  },
  '.backgroundContainer': {
    display: 'flex',
    height: '100%',
    maxWidth: '1440px',
    margin: 'auto',
  },
  '.banner': {
    width: '40% !important',
    display: 'flex',
    flexDirection: 'column',
    // background: 'linear-gradient(90deg, #006FCF 0%, #00175A 100%)',
    background: 'linear-gradient(270deg, #006FCF 0%, #00175A 100%)',
    justifyContent: 'center',
  },
  '.bannerHeader': {
    color: '#FFFFFF',
    fontFamily: '"Guardian Egyp"',
    fontSize: '48px',
    letterSpacing: '0',
    lineHeight: '60px',
  },
  '.bannerText': {
    paddingTop: '26px',
    color: '#FFFFFF',
    fontFamily: '"Helvetica Neue"',
    fontSize: '16px',
    letterSpacing: '0',
    lineHeight: '22px',
  },
  '.registration': {
    width: '60% !important',
    padding: '100px 0px 0px 35px',
  },
  '.stepsContainer': {
    marginTop: '35px',
    display: 'flex',
  },
  '.registrationHeader': {
    marginTop: '30px',
    color: '#00175A',
    fontFamily: 'BentonSans',
    fontSize: '24px',
    lineHeight: '44px',
    fontWeight: '300',
    letterSpacing: '0',
  },
};

export default registerStyles;
